module.exports = __webpack_public_path__ + "media/toolkits/COVID19-header-small-b14fbb71.jpg";